import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '@/utils/analytics';

interface GoogleAnalyticsProviderProps {
  children: React.ReactNode;
}

const GoogleAnalyticsProvider: React.FC<GoogleAnalyticsProviderProps> = ({ children }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Initialize GA with your tracking ID from environment variables
    const trackingId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
    
    if (trackingId) {
      initGA(trackingId);
    }
  }, []);
  
  useEffect(() => {
    // Track page views whenever the location changes
    if (import.meta.env.VITE_GOOGLE_ANALYTICS_ID) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);
  
  return <>{children}</>;
};

export default GoogleAnalyticsProvider; 